import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/parth.png'


const _hoisted_1 = { class: "flex flex-col lg:flex-row justify-evenly" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "flex flex-col w-full justify-center px-8 space-y-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Parth Shah",
    class: "rounded-md grayscale -rotate-6 hover:grayscale-0"
  })
], -1)
const _hoisted_3 = { class: "flex flex-col w-full justify-center px-8 space-y-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "font-extralight text-6xl" }, " From Concept To Code, Scalable Solutions That Stand The Test ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "font-extralight text-2xl leading-loose" }, " My passion for backend development is fueled by a desire to create custom solutions that exceed your expectations and scale with your business. I specialize in building efficient, secure, and scalable backend systems that power web and mobile applications of all kinds. From API development to database management, I'll work with you to create a backend solution that meets your needs. ", -1)
const _hoisted_6 = { class: "flex flex-row justify-between" }
const _hoisted_7 = {
  type: "button",
  class: "inline-flex items-center bg-pink-900 hover:bg-pink-900/90 text-slate-200 dark:bg-yellow-500 dark:hover:bg-yellow-500/90 dark:text-gray-900 font-normal py-2 px-4 rounded"
}
const _hoisted_8 = {
  target: "_blank",
  href: "https://firebasestorage.googleapis.com/v0/b/website-b674d.appspot.com/o/documents%2FParth_Resume.pdf?alt=media",
  class: "inline-flex items-center"
}
const _hoisted_9 = {
  type: "button",
  class: "inline-flex items-center bg-pink-900 hover:bg-pink-900/90 text-slate-200 dark:bg-yellow-500 dark:hover:bg-yellow-500/90 dark:text-gray-900 font-normal py-2 px-4 rounded"
}
const _hoisted_10 = {
  href: "mailto:contact@shahparth.me",
  class: "inline-flex items-center"
}

import { ArrowTopRightOnSquareIcon, InboxIcon } from "@heroicons/vue/24/solid";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", _hoisted_7, [
          _createElementVNode("a", _hoisted_8, [
            _createTextVNode(" Resume "),
            _createVNode(_unref(ArrowTopRightOnSquareIcon), { class: "w-4 h-4 ml-2 fill-slate-200 dark:fill-gray-900" })
          ])
        ]),
        _createElementVNode("button", _hoisted_9, [
          _createElementVNode("a", _hoisted_10, [
            _createTextVNode(" Contact "),
            _createVNode(_unref(InboxIcon), { class: "w-4 h-4 ml-2 fill-slate-200 dark:fill-gray-900" })
          ])
        ])
      ])
    ])
  ]))
}
}

})